<div fxLayout="row" fxLayoutAlign="center start">
  <h1>Risorsa non trovata.</h1>
</div>

<div fxLayout="row" fxLayoutAlign="center start">
  <button class="themeReplica" mat-raised-button routerLink="/">Ritorna alla pagina principale.</button>
</div>
